import styled from '@emotion/styled';
import Paper from '@mui/material/Paper';
import { ReactElement } from 'react';
import { ReactComponent as UploadIcon } from '../../../assets/images/landscape-upload-image.svg';
import { VesselMediaFileInterface } from '../../../utils/types/vesselMediaFile';
import CardHeader from '@mui/material/CardHeader';
import Box from '@mui/material/Box';
import Divider from '@mui/material/Divider';
import IconButton from '@mui/material/IconButton';
import { ReactComponent as CloseIcon } from '../../../assets/images/close-circle.svg';
import './VesselMediaFileItem.scss';
import { Grid } from '@mui/material';

const Item = styled(Paper)((c) => ({
  display: 'flex',
  //@ts-ignore
  padding: c.theme.spacing(1),
  textAlign: 'center',
  //@ts-ignore
  color: c.theme.palette.text.secondary,
  height: 77,
  background: '#FFFFFF',
  borderRadius: '8px',
  marginBottom: '16px'
}));

interface VesselMediaFileItemProps {
  file: VesselMediaFileInterface;
  onClickDownload: (file: VesselMediaFileInterface) => void;
  onClickDelete: (file: VesselMediaFileInterface) => void;
  selectedMode?: boolean;
  setSelectedId?: (id: string | null, isSelected: boolean) => void;
}

const VesselMediaFileItem = (props: VesselMediaFileItemProps): ReactElement => {
  const handleClickDownload = () => {
    props.onClickDownload(props.file);
  };

  return (
    <Grid
      className="vessel-media-item-container"
      gap={2}
      item
      xs={12}
      sm={6}
      md={4}
      lg={3}
      onClick={() => {
        if (props.selectedMode) {
          return;
        }
        handleClickDownload();
      }}>
      {props.selectedMode && (
        <input
          type="checkbox"
          onChange={(value) => {
            if (props.setSelectedId) {
              props.setSelectedId(props.file.id, value.target.checked);
            }
          }}
        />
      )}
      <img src={props.file.storeable_asset.download_url} width={50} height={50} />
      <p>{props.file.name}</p>
      <Box sx={{ display: 'flex', alignItems: 'center' }}>
        <Divider orientation="vertical" variant="middle" flexItem />
      </Box>
    </Grid>
  );
};

export default VesselMediaFileItem;
